module.exports = "query Contributions($campaignId: ID!) {\n  contributions(campaignId: $campaignId) {\n    sourceName\n    amount\n    createdAt\n  }\n}"